import axios from "axios";
import configData from "../../config/config.json";

export const selectLanguage = (language, callback) => async dispatch => {
  await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/translations?language="+language, { withCredentials: true })
    .then((response) => {
      if (response.data.content) {
        dispatch({ type: 'SELECT_LANGUAGE', language })
        dispatch({ type: 'UPDATE_TRANSLATIONS', translations: JSON.parse(response.data.content.translations) }); 
        callback( { error: false } );
      } else {
        dispatch({ type: 'SELECT_LANGUAGE', language })
        callback( { error: true, message: response.data.message });
      }
    }, (error) => {
      dispatch({ type: 'SELECT_LANGUAGE', language })
      callback( { error: true, message: "Login Error" });
    });
};

